// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5811":"b14b473b50e16efb","9211":"33fb5c41fa59de32"}[chunkId] + ".js";
};